import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { getOrderByLotNo, getOrderBySku } from "../Api/ApiCalls";
import LoadingSpinner from "../common/Loading";
import log from "../core/log";
import { yupResolver } from "@hookform/resolvers/yup";
import { searchOrderValidationSchema } from "../common/Validation";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { useTable, usePagination } from "react-table";

export const SearchOrder = () => {
 const [loading, setLoading] = useState(false);
 const formOptions = { resolver: yupResolver(searchOrderValidationSchema) };
 const [orders, setOrders] = useState([]);
 const [lots, setLots] = useState([]);
 const {
  register,
  handleSubmit,
  formState: { errors },
  reset,
 } = useForm(formOptions);

 const columns = React.useMemo(
  () => [
   {
    Header: "SKU",
    accessor: "sku",
   },
   {
    Header: "Lot No",
    accessor: "lot_no",
   },
   {
    Header: "Corporation",
    accessor: "corporation_name",
   },
   {
    Header: "Organization",
    accessor: "organization_code",
   },
   {
    Header: "Store",
    accessor: "store.store_name",
   },
   {
    Header: "Location",
    accessor: "location",
   },
   {
    Header: "User",
    accessor: "store.primary_contact.phone_number",
   },
   {
    Header: "Status",
    accessor: "status",
   },
   {
    Header: "Expiry Date",
    accessor: "expiry_timestamp",
   },
  ],
  []
 );

 const {
  getTableProps,
  getTableBodyProps,
  headerGroups,
  page,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  prepareRow,
  pageOptions,
  state,
  setPageSize,
  pageSize,
 } = useTable({ columns, data: orders }, usePagination);
 const { pageIndex } = state;

 const getTime = (timeStamo) => {
  return moment(timeStamo).format("YYYY-MM-DD");
 };
 const onSubmit = async (form) => {
  try {
   setLoading(true);
   setLots([]);
   setOrders([]);
   const data = await getOrderBySku(form?.sku, form?.lot_no);
   if (data && data.length !== 0) {
    setLots(data);
   } else {
    toast.info("Data not found");
   }
   reset({ sku: "", lot_no: "" });
   setLoading(false);
  } catch (err) {
   log(`Error while fetching order: `, err);
   setLoading(false);
  }
 };

 useEffect(() => {
  setPageSize(25);
 }, []);

 const handleDownload = () => {
  const finaArr = [];
  const sku = orders[0].sku;
  const lot = orders[0].lot_no;
  orders.forEach((data) => {
   const tempObj = {
    Corporation: data?.corporation_name,
    Organization: data?.organization_code,
    SKU: data?.sku,
    LotNo: data?.lot_no,
    Store: data?.store?.store_name,
    User: data?.store?.primary_contact?.phone_number,
    Location: data?.location,
    Expiry: getTime(data?.expiry_timestamp),
   };
   finaArr.push(tempObj);
  });

  const filename = `${sku}-${lot}`;
  const sheet = XLSX.utils.json_to_sheet(finaArr);
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, "Sheet1");
  XLSX.writeFile(book, `${filename}.xlsx`);
 };

 const resetFields = (data) => {
  if (!data || !Object.keys(data).length) return;
  const tempObj = {};
  Object.keys(data).forEach((field) => {
   tempObj[field] = "";
  });
  reset(tempObj);
 };

 const searchByLotNo = async (sku, lot_no) => {
  try {
   setLoading(true);
   setOrders([]);
   const data = await getOrderByLotNo(sku, lot_no);
   if (data && data.length !== 0) {
    setOrders(data);
   } else {
    toast.info("Data not found");
   }
   resetFields(data);
   setLoading(false);
  } catch (err) {
   log(`Error while fetching order: `, err);
   setLoading(false);
  }
 };
 return (
  <>
   <div className="grid grid-rows-1 min-h-screen">
    <div className="flex overnpmflow-hidden">
     <div className="content relative flex-1 pb-10">
      <form onSubmit={handleSubmit(onSubmit)}>
       <h2 className="text-4xl text-[#96BF61] font-bold">Search By Sku</h2>
       {loading && <LoadingSpinner />}
       <div className="grid grid-cols-12 mt-5">
        <div className="col-span-12 lg:col-span-12">
         <div className=" shadow-md rounded">
          <div className="bg-white rounded-[21px] p-10 mt-6">
           <div className="flex items-end">
            <div className=" w-1/3 py-6">
             <div className="relative">
              <span className="text-red-600 top-0 absolute my-4 block">
               {errors?.sku?.message}
              </span>
              <label
               htmlFor="sku"
               className="text-black font-semibold text-sm mb-4 block"
              >
               SKU
               <span className="text-red-600">*</span>
              </label>
              <input
               id="sku"
               {...register("sku", {
                required: true,
               })}
               className={`py-3 block shadow-md w-full px-4 mt-0 bg-transparent  border border-b-2 appearance-none w-[90%] focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
               placeholder="Enter SKU"
              />
             </div>
            </div>
            <div className="w-1/3 py-6">
             <div className="relative px-4">
              <span className="text-red-600 top-0 absolute my-4 block">
               {errors?.lot_no?.message}
              </span>
              <label
               htmlFor="lot_no"
               className="text-black font-semibold text-sm mb-4 block"
              >
               LOT NO
              </label>
              <input
               id="lot_no"
               {...register("lot_no")}
               className={`py-3 block shadow-md w-full px-4 mt-0 bg-transparent  border border-b-2 appearance-none w-[90%] focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
               placeholder="Enter Lot No"
              />
             </div>
            </div>
            <div className="text-center w-1/3 py-6">
             <button
              type="form"
              className="w-[60%] px-4 py-2 text-lg text-white transition-all duration-150 ease-linear rounded-md shadow outline-none bg-[#134d86] hover:bg-[#134d86] hover:shadow-lg focus:outline-none"
             >
              Search
             </button>
            </div>
           </div>
           {orders.length !== 0 && (
            <div className="">
             <div className="flex justify-between items-center mb-6">
              <div
               onClick={() => {
                setOrders([]);
               }}
               className="cursor-pointer"
              >
               <svg
                fill="#000000"
                width="20px"
                height="20px"
                viewBox="0 0 200 200"
                data-name="Layer 1"
                id="Layer_1"
               >
                <title />
                <path d="M160,89.75H56l53-53a9.67,9.67,0,0,0,0-14,9.67,9.67,0,0,0-14,0l-56,56a30.18,30.18,0,0,0-8.5,18.5c0,1-.5,1.5-.5,2.5a6.34,6.34,0,0,0,.5,3,31.47,31.47,0,0,0,8.5,18.5l56,56a9.9,9.9,0,0,0,14-14l-52.5-53.5H160a10,10,0,0,0,0-20Z" />
               </svg>
              </div>
              <div
               onClick={handleDownload}
               className="bg-[#134d86] px-6 py-3 rounded-md"
              >
               <div className="cursor-pointer text-white font-bold underline hover:no-underline">
                Click here to download
               </div>
              </div>
             </div>
             <div className="overflow-y-scroll rounded-[21px] rounded-bl-none rounded-br-none">
              <table className="px-4 w-full" id="table" {...getTableProps()}>
               <thead className="border bg-white">
                {headerGroups.map((headerGroup) => (
                 <tr
                  className="rounded-md"
                  {...headerGroup.getHeaderGroupProps()}
                 >
                  {headerGroup.headers.map((column) => (
                   <th
                    data-type="number"
                    scope="col"
                    className="font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6 w-[12.5%]"
                    {...column.getHeaderProps()}
                   >
                    {column.render("Header")}
                   </th>
                  ))}
                 </tr>
                ))}
               </thead>

               <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                 prepareRow(row);
                 return (
                  <tr
                   className="bg-white border transition duration-300 ease-in-out hover:bg-gray-100"
                   {...row.getRowProps()}
                  >
                   {row.cells.map((cell) => (
                    <td
                     className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-2 whitespace-nowrap truncate..."
                     {...cell.getCellProps()}
                    >
                     {cell.column.id === "expiry_timestamp"
                      ? getTime(cell.render("Cell"))
                      : cell.render("Cell")}
                    </td>
                   ))}
                  </tr>
                 );
                })}
               </tbody>
              </table>
             </div>
             <div className="mt-6 flex justify-end items-center">
              <div className="mr-4">
               <span className="text-[#121212]">Items per page</span>
              </div>
              <div className="relative mr-4">
               <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                className="border border-[#024C85] rounded-md pl-6 pr-9 outline-none bg-[#EDF9FF] font-bold text-[#024C85]"
               >
                {[25, 50].map((pageSize) => (
                 <option key={pageSize} value={pageSize}>
                  {pageSize}
                 </option>
                ))}
               </select>
               <div className="absolute right-[7px] top-[15px] pointer-events-none">
                <svg width="20" height="20" viewBox="0 0 24 24">
                 <path
                  d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                  fill="#1D192B"
                 ></path>
                </svg>
               </div>
              </div>
              <div>
               <span className="mr-4">
                Page {pageIndex + 1} of {pageOptions.length}
               </span>
               <button
                className={`${
                 !canPreviousPage ? "bg-[#EDF9FF]" : "bg-tranparent"
                } px-[22px] py-[10px] rounded-[4px] mr-4 cursor-pointer border border-[#024C85] text-[#024C85] font-bold`}
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
               >
                <svg width="8" height="10" viewBox="0 0 8 10" fill="none">
                 <path
                  d="M7.08748 1.175L5.91248 0L0.912476 5L5.91248 10L7.08748 8.825L3.27081 5L7.08748 1.175Z"
                  fill="#024C85"
                 />
                </svg>
               </button>
               <button
                className={`${
                 !canNextPage ? "bg-[#EDF9FF]" : "bg-tranparent"
                } px-[22px] rounded-[4px] py-[10px] cursor-pointer border border-[#024C85] text-[#024C85] font-bold`}
                onClick={() => nextPage()}
                disabled={!canNextPage}
               >
                <svg width="8" height="10" viewBox="0 0 8 10" fill="none">
                 <path
                  d="M2.08748 0L0.912476 1.175L4.72914 5L0.912476 8.825L2.08748 10L7.08748 5L2.08748 0Z"
                  fill="#024C85"
                 />
                </svg>
               </button>
              </div>
             </div>
            </div>
           )}
           {lots.length !== 0 && !orders.length && (
            <div className="p-7">
             <div className=" overflow-y-scroll rounded-[21px] rounded-bl-none rounded-br-none w-full">
              <table className="px-4 w-full">
               <thead className="bg-indigo-50 border transition duration-300 ease-in-out hover:bg-gray-100">
                <th className="font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-10 py-6">
                 SKU
                </th>
                <th className="font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-10 py-6">
                 Lot No
                </th>
               </thead>

               {lots.map((element) => {
                return (
                 <>
                  <tr
                   key={element?.id}
                   className="bg-white border text-left transition duration-300 ease-in-out hover:bg-gray-100"
                  >
                   <td className="text-gray-900  border border-r-0 border-l-0 font-light px-8 py-4 whitespace-nowrap">
                    {element?.sku}
                   </td>
                   <td
                    onClick={() => {
                     searchByLotNo(element.sku, element.lot_no);
                    }}
                    className="text-gray-900  border border-r-0 border-l-0 font-light px-8 py-4 whitespace-nowrap"
                   >
                    <span className="underline text-blue-500 cursor-pointer ">
                     {element?.lot_no}
                    </span>
                   </td>
                  </tr>
                 </>
                );
               })}
              </table>
             </div>
            </div>
           )}
          </div>
         </div>
        </div>
       </div>
      </form>
     </div>
    </div>
   </div>
  </>
 );
};
